<template>
  <div v-cloak v-show="show" id="desktop" class="w-full h-full text-kozel-white">
    <div class="container mx-auto py-10 text-center min-h-[100vh] flex flex-col items-center justify-evenly">
      <div class="relative w-full">
        <h1 class="text-3xl leading-[1.25]">Dostęp do konkursu został zablokowany.</h1>
        <p class="text-xl mt-5">Skontaktuj się z administratorem konkursu.</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
#desktop {
  background-image: url("../assets/images/backgrounds/bg-desktop.webp");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;

  font-family: 'ApexSerif', 'serif';
  font-weight: 400;
}
</style>
<script setup lang="ts">

import {onBeforeMount, ref} from "vue";
import ApiHelper from "@/helpers/apiHelper.ts";
import axios from "axios";
import router from "@/router";

const show = ref(false);

onBeforeMount(async () => {
  try {
    const uninterceptedAxiosInstance = axios.create();
    const response = await uninterceptedAxiosInstance.get(ApiHelper.checkIp());

    if (response.status === 200 && response.data.status === "allowed") {
      router.push('/');
    } else {
      show.value = true;
      throw new Error("IP blocked (status not allowed)");
    }
  } catch (error) {
    show.value = true;
    // if (axios.isAxiosError(error) && error.response?.status === 403) {
    //   console.warn("Zablokowane IP - 403");
    // }
  }
});


</script>